import React, { Component } from "react";
import { Row, Col, Container, Card, Form, FormGroup } from "react-bootstrap";
import moment from "moment";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { components } from 'react-select';
import Button from "react-bootstrap/Button";
import Select from "react-select";
import compose from "lodash.flowright";
import { Spinner } from "react-bootstrap";
import SelectBoxWithDisabledOption from '../selectdropdown/SelectBoxWithDisabledOption';
import { isBrowser } from "react-device-detect";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import PreloaderTwo from '../preloader/PreloaderTwo';
import DataTableWithOutSearch from "../datatables/DataTableWithOutSearch";
import TopStudentsChart from "./StudentChart";
import ExamReportForOverall from "./ExamReportForOverall";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import MultiSelectFilters from "../reusableDropDownComponents/MultiSelectDropdown";
import { filterStudentsData } from "../reusableDropDownComponents/filterHelper";
import { buildFilterConfig } from "../reusableDropDownComponents/FilterConfig";
import useStudentFilters from "../reusableDropDownComponents/CutormHookFilter";
import { stateWiseExamColumns, districtWiseExamColumns, cityWiseExamColumns, branchWiseExamColumns, sectionWiseExamColumns } from "./TableCoumns";
import { withApollo } from "react-apollo";

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
        state_id
        city_id
        district_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
                subject_id
              }
      }
      globalBranches {
        id
        branch_name
        state_id
        city_id
        district_id
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
         states {
      state_id
      state_name
    }
    districts {
      id
      district_name
      state_id
    }
    cities {
      id
      district_id
      region_id
      city_name
      timestamp
    }
    }
  }
`;
const FETCH_OVERALL_EXAMS_COUNTS = gql`
query (
  $institution_id: Int!,
  $exam_type: [Int],
  $days: Int,
  $state_ids: [Int],
  $district_ids: [Int],
  $city_ids: [Int],
  $branch_ids: [Int],
  $section_ids: [Int]
) {
  getCountsForCollegeOverallExams(
    institution_id: $institution_id,
    exam_type: $exam_type,
    days: $days,
    state_ids: $state_ids,
    district_ids: $district_ids,
    city_ids: $city_ids,
    branch_ids: $branch_ids,
    section_ids: $section_ids
  ) {
    totalExams
    totalStudents
    avgScore
    bestScore
    lessScore
  }
}
`;
const FETCH_STATE_WISE_DATA = gql`
query ( $institution_id: Int!,
  $exam_type: [Int],
  $state_ids: [Int]) {
  getStateWiseExamStatsCollegeOverall(
    institution_id: $institution_id,
    exam_type: $exam_type,
    state_ids: $state_ids
  ) {
     state_id
  state_name

  exam_paper_id
  exam_name

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`;


const FETCH_SECTION = gql`
query ($institution_id: Int!, $branch_id: Int!) {
  getSectionNames(institution_id: $institution_id, branch_id: $branch_id) {
    id
    section_name
  }
} 
`

const FETCH_EXAMS = gql`
query($institution_id: Int!){
  getDashBoardExams(institution_id : $institution_id){
    quiz_exams{
      id
      exam_name
      exam_type
      class_id
      start_time

    }
    full_exams{
      id
      exam_mode
      exam_name
      exam_type
      class_id 
      start_time
      end_time
      section{
        id
        section_name
        branch_id
        exam_id
      }
    }
  }
}
`;

const levelOptions = [
    { value: 1, label: "State" },
    { value: 2, label: "District" },
    { value: 3, label: "City" },
    { value: 4, label: "Branch" },
    { value: 5, label: "Section" },
    { value: 6, label: "Exam" },
    { value: 7, label: "Class" },
];

class OverallReportsCollege extends Component {
    constructor(props) {
        super(props);
        this.reportRef = React.createRef();
        this.state = {
            exam_typeValue: { value: 2, label: "NEET" },
            exam_type: [2],
            examTypeOptions: [],
            toggled: Cookies.get("toggle") || "wrapper",
            tableHeaderData: {
                Title: 'Exam wise data'
            },
            // Multi-select filter state
            levelSelectedValue: [{ value: 1, label: "State" }],
            statesSelectedValue: [],
            selectedDistrictsValues: [],
            selectedCityValue: [],
            branchSelectedvalue: [],
            sectionSelectedvalue: [],
            examSelectedvalue: [],      // Added for exam filter
            classSelectedvalue: [],      // Added for class filter

            // Options for dropdowns
            getLevelArr: levelOptions,
            getStateArr: [],
            getDistricts: [],
            getCities: [],
            getBranchArr: [],
            getSectionArr: [],
            getExamArr: [],              // Added for exam options
            getClassArr: [],             // Added for class options
            districtWiseExamStats: [],
            isDistrictLoading: false,
            isCityLoading: false,
            cityWiseExamStats: [],
            isBranchLoading: false,
            branchWiseExamStats: [],
            isSectionLoading: false,
            sectionWiseExamStats: [],
            // Other state
            dateFilter: "All",
            showFilter: false,
            showReportSection: false,
            isReportLoading: false,
            dateFilterOptions: [
                { value: "All", label: "All" },
                { value: 1, label: "1 Day" },
                { value: 7, label: "7 Days" },
                { value: 15, label: "15 Days" },
                { value: 30, label: "30 Days" },
                { value: 60, label: "60 Days" },
                { value: 90, label: "90 Days" }
            ],

        };
    }

    handleExamClick = (row) => {
        this.setState({
            isReportLoading: true,   // ✅ start loader
            showReportSection: true,
            exam_id: row.exam_paper_id,
            exam_name: row.exam_name,
            exam_type: this.state.exam_type,
            exam_typeValue: this.state.exam_typeValue,
            examsglobals: this.props.globals.globals.exams,
        }, () => {
            if (this.reportRef?.current) {
                this.reportRef.current.scrollIntoView({ behavior: "smooth" });
            }
        });
    };





    tableUserData(data) {
        if (!data) return [];

        return data.map((item, index) => ({
            id: item.id,
            slno: index + 1,
            exam_name: item.exam_name,
            exam_attempts: item.exam_attempts || 0,
            avg_marks: item.avg_marks ? parseFloat(item.avg_marks).toFixed(2) : 0,
            avg_accuracy: item.avg_accuracy ? parseFloat(item.avg_accuracy).toFixed(2) : 0,
            best_score: item.best_score || 0
        }));
    }

    defaultSorted = [
        {
            dataField: "slno",
            order: "asc"
        }
    ];

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        const next =
            toggled === "wrapper"
                ? "wrapper sidebar-enable"
                : "wrapper";

        this.setState({ toggled: next });
        Cookies.set("toggle", next);
    };

    handleTabChange = (key) => {
        const type = key === "adaptive_exams" ? "adaptive" : "remedial";
        if (this.props.getCountsForCollegeOverallExams && this.props.getCountsForCollegeOverallExams.refetch) {
            this.props.getCountsForCollegeOverallExams.refetch({
                institution_id: parseInt(Cookies.get("institutionid")),
                type,
                exam_paper_id: 0
            });
        }
    };
    componentDidMount() {
        this.initializeFilterOptions();
    }
    initializeFilterOptions() {
        const { globals } = this.props;

        if (!globals?.globals) {
            console.log("Globals data not available yet");
            return;
        }

        const globalsData = globals.globals;

        // Get states from globals
        const stateOptions = globalsData.states?.map(state => ({
            value: parseInt(state.state_id),
            label: state.state_name
        })) || [];

        // Get districts from globals
        const districtOptions = globalsData.districts?.map(district => ({
            value: district.id,
            label: district.district_name
        })) || [];

        // Get cities from globals
        const cityOptions = globalsData.cities?.map(city => ({
            value: parseInt(city.id),
            label: city.city_name
        })) || [];

        // Get branches from globals
        const branchOptions = globalsData.globalBranches?.map(branch => ({
            value: parseInt(branch.id),
            label: branch.branch_name
        })) || [];

        // Get sections from globals
        const sectionOptions = globalsData.globalSections?.map(section => ({
            value: parseInt(section.id),
            label: section.section_name
        })) || [];

        // Get exams from globals
        const examOptions = globalsData.exams?.map(exam => ({
            value: parseInt(exam.id),
            label: exam.exam
        })) || [];

        // Get classes from globals
        const classOptions = globalsData.classes?.map(cls => ({
            value: cls.id,
            label: cls.class
        })) || [];

        console.log("Initialized filter options:", {
            stateOptions,
            districtOptions,
            cityOptions,
            branchOptions,
            sectionOptions,
            examOptions,
            classOptions
        });

        this.setState({
            getStateArr: stateOptions,
            getDistricts: districtOptions,
            getCities: cityOptions,
            getBranchArr: branchOptions,
            getSectionArr: sectionOptions,
            getExamArr: examOptions,
            getClassArr: classOptions,
        });
    }

    componentDidUpdate(prevProps) {
        // Initialize filters when globals data loads
        if (
            !this.props.globals.loading &&
            this.props.globals.globals &&
            prevProps.globals.loading
        ) {
            this.initializeFilterOptions();
        }

        // Your existing exam type options logic
        if (
            !this.props.globals.loading &&
            this.props.globals.globals?.exams &&
            prevProps.globals.globals?.exams !== this.props.globals.globals?.exams
        ) {
            const examTypeArr = this.props.globals.globals.exams.map(item => ({
                value: Number(item.id),
                label: item.exam
            }));

            const defaultExam = examTypeArr.find(e => e.value === 2);

            this.setState({
                examTypeOptions: examTypeArr,
                exam_typeValue: defaultExam || examTypeArr[0],
                exam_type: defaultExam?.value || 2
            });
        }
    }

    checkAndInitializeFilters() {
        // Small delay to ensure data is available
        setTimeout(() => {
            this.initializeFilterOptions();
        }, 100);
    }

    selecthandleInputChange = (name, value, option) => {

        const examType = parseInt(value); // convert string → number

        this.setState({
            exam_typeValue: option,
            exam_type: examType
        }
            // , () => {

            //     console.log("Selected exam_type:", this.state.exam_type);

            //     this.props.getExams.refetch({
            //         institution_id: parseInt(Cookies.get("institutionid")),
            //         exam_type: examType
            //     });

            //     this.props.getExamsData.refetch({
            //         institution_id: parseInt(Cookies.get("institutionid")),
            //         exam_type: examType
            //     });

            //     this.props.getTopStudents.refetch({
            //         institution_id: parseInt(Cookies.get("institutionid")),
            //         exam_type: examType
            //     });

            // }
        );
    };
    setReportLoading = (value) => {
        this.setState({ isReportLoading: value });
    };

    handleLocationChange = (name, option) => {
        console.log(name, option, "option")
        if (name === "state") {
            this.setState({
                stateValue: option,
                districtOptions: option.districts || [],
                districtValue: null,
                cityValue: null,
                branchValue: null,
                sectionValue: null,
                cityOptions: [],
                branchOptions: [],
                sectionOptions: []
            });


        }

        if (name === "district") {
            this.setState({
                districtValue: option,
                cityOptions: option.cities || [],
                cityValue: null,
                branchValue: null,
                sectionValue: null,
                branchOptions: [],
                sectionOptions: []
            });


        }

        if (name === "city") {
            this.setState({
                cityValue: option,
                branchOptions: option.branches || [],
                branchValue: null,
                sectionValue: null,
                sectionOptions: []
            });



        }

        if (name === "branch") {
            this.setState({
                branchValue: option,
                sectionOptions: option.sections || [],
                sectionValue: null
            });


        }

        if (name === "section") {
            this.setState({ sectionValue: option });
        }
        if (name === "exam_type") {

            this.setState({
                exam_typeValue: option,
                exam_type: option.value
            })
            // this.props.getExamScheduleSubTypeQuestions.refetch({
            //     institution_id: parseInt(Cookies.get("institutionid")),
            //     type: option.value
            // });
        }

    };

    handleDateFilterChange = (option) => {

        this.setState(
            {
                dateFilter: option.value
            }
        );
    };

    handleFilter = async () => {
        // Extract IDs from selected values
        const stateIds = this.state.statesSelectedValue.map(s => s.value);
        const districtIds = this.state.selectedDistrictsValues.map(d => d.value);
        const cityIds = this.state.selectedCityValue.map(c => c.value);
        const branchIds = this.state.branchSelectedvalue.map(b => b.value);
        const sectionIds = this.state.sectionSelectedvalue.map(s => s.value);
        const examIds = this.state.examSelectedvalue.map(e => e.value);
        const classIds = this.state.classSelectedvalue.map(c => c.value);

        console.log("Filtering with:", {
            stateIds,
            districtIds,
            cityIds,
            branchIds,
            sectionIds,
            examIds,
            classIds,
            exam_type: this.state.exam_type,
            dateFilter: this.state.dateFilter
        });
        if (sectionIds.length > 0) {
            this.setState({ isSectionLoading: true })
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $section_ids: [Int]) {
  getSectionwiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    section_ids: $section_ids
  ) {
      state_id
  state_name

  district_id
  district_name
  city_id
city_name
branch_id
branch_name
section_id
section_name

  section_students
  section_avg
  section_max
  section_min

  branch_students
  branch_avg
  branch_max
  branch_min

  city_students
  city_avg
  city_max
  city_min
  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
}
}`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.exam_type,
                    section_ids: sectionIds,
                }
            });
            this.setState({
                sectionWiseExamStats: res.data.getSectionWiseExamStats,
                isSectionLoading: false
            });
        }
        if (branchIds.length > 0 && sectionIds.length == 0) {
            this.setState({ isBranchLoading: true })
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $branch_ids: [Int]) {
  getBranchWiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    branch_ids: $branch_ids
  ) {
      state_id
  state_name

  district_id
  district_name
  city_id
city_name
branch_id
branch_name

branch_students
branch_avg
branch_max
branch_min

city_students
city_avg
city_max
city_min
  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.exam_type,
                    branch_ids: branchIds.length > 0 ? branchIds : null,
                },
            })
            this.setState({
                branchWiseExamStats: res.data.getBranchWiseExamStats,
                isBranchLoading: false,
            })
        }
        if (cityIds.length > 0 && branchIds.length === 0) {
            this.setState({ isCityLoading: true });
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $city_ids: [Int]) {
  getCityWiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    city_ids: $city_ids
  ) {
      state_id
  state_name

  district_id
  district_name
  city_id
city_name
city_students
city_avg
city_max
city_min
  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.exam_type,
                    city_ids: cityIds.length > 0 ? cityIds : null,
                },
            });
            console.log("res", res.data.getCityWiseExamStats);
            this.setState({
                cityWiseExamStats: res.data.getCityWiseExamStats,
                isCityLoading: false,
            });
        }
        if (districtIds && districtIds.length > 0 && cityIds.length === 0) {
            this.setState({ isDistrictLoading: true });
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $district_ids: [Int]) {
  getDistrictWiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    district_ids: $district_ids
  ) {
      state_id
  state_name

  district_id
  district_name

  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.exam_type,
                    district_ids: districtIds.length > 0 ? districtIds : null,
                },
            });
            console.log("res", res.data.getDistrictWiseExamStats);
            this.setState({
                districtWiseExamStats: res.data.getDistrictWiseExamStats,
                isDistrictLoading: false,
            });
        }

        if (stateIds.length > 0 && districtIds.length === 0) {
            this.props.getStateWiseExamStatsCollegeOverall.refetch({
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_type: this.state.exam_type,

                state_ids: stateIds.length > 0 ? stateIds : null,

            });
        }

        this.props.getCountsForCollegeOverallExams.refetch({
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_type: this.state.exam_type,
            days: null,
            state_ids: stateIds.length > 0 ? stateIds : null,
            district_ids: districtIds.length > 0 ? districtIds : null,
            city_ids: cityIds.length > 0 ? cityIds : null,
            branch_ids: branchIds.length > 0 ? branchIds : null,
            section_ids: sectionIds.length > 0 ? sectionIds : null,
            exam_ids: examIds.length > 0 ? examIds : null,
            class_ids: classIds.length > 0 ? classIds : null,
        });
    };

    handleReset = () => {
        const stateIds = this.state.statesSelectedValue.map(s => s.value);
        this.setState({
            statesSelectedValue: [],
            selectedDistrictsValues: [],
            selectedCityValue: [],
            branchSelectedvalue: [],
            sectionSelectedvalue: [],
            examSelectedvalue: [],
            classSelectedvalue: [],
            dateFilter: "All",
            stateWiseExamStats: [],
            districtWiseExamStats: [],
            cityWiseExamStats: [],
            branchWiseExamStats: [],
            showReportSection: false,
        });

        // Reset all filter options
        this.initializeFilterOptions();

        this.props.getStateWiseExamStatsCollegeOverall.refetch({
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_type: this.state.exam_type,
            state_ids: stateIds.length > 0 ? stateIds : null,
        });
        this.props.getCountsForCollegeOverallExams.refetch({
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_type: this.state.exam_type,
            days: null,
            state_ids: null,
            district_ids: null,
            city_ids: null,
            branch_ids: null,
            section_ids: null,
            exam_ids: null,
            class_ids: null,
        });
    };
    //



    handleMultipleSelectInputChange = (selectedValues, filterName) => {
        console.log(`Filter changed: ${filterName}`, selectedValues);
        const { globals } = this.props;
        const globalsData = globals?.globals;

        if (!globalsData) return;

        if (filterName === "level") {
            this.setState({
                levelSelectedValue: selectedValues,

            });
            if (selectedValues.length === 0) {

                this.handleReset();
            }
            console.log("levelSelectedValue", this.state.levelSelectedValue);
            // if (selectedValues.length > 0) {
            //     const levelIds = selectedValues.map(s => s.value);

            //     // Filter states based on selected levels
            //     const filteredStates = globalsData.states?.filter(
            //         state => levelIds.includes(state.level_id)
            //     ) || [];

            //     const stateOptions = filteredStates.map(state => ({
            //         value: state.id,
            //         label: state.state
            //     }));

            //     this.setState({
            //         getStateArr: stateOptions,
            //     });
            // } else {

            //     const stateOptions = globalsData.states?.map(state => ({
            //         value: state.id,
            //         label: state.state
            //     })) || [];

            //     this.setState({
            //         getStateArr: stateOptions,
            //     });
            // }
        }

        if (filterName === "states") {
            this.setState({
                statesSelectedValue: selectedValues,
                selectedDistrictsValues: [],
                selectedCityValue: [],
                branchSelectedvalue: [],
                sectionSelectedvalue: [],
                examSelectedvalue: [],
                classSelectedvalue: [],
            });

            if (selectedValues.length > 0) {
                const stateIds = selectedValues.map(s => s.value);

                // Filter districts based on selected states
                const filteredDistricts = globalsData.districts?.filter(
                    district => stateIds.includes(district.state_id)
                ) || [];

                const districtOptions = filteredDistricts.map(d => ({
                    value: d.id,
                    label: d.district_name
                }));

                // Filter branches based on selected states
                const filteredBranches = globalsData.globalBranches?.filter(
                    branch => stateIds.includes(branch.state_id)
                ) || [];

                const branchOptions = filteredBranches.map(b => ({
                    value: parseInt(b.id),
                    label: b.branch_name
                }));

                this.setState({
                    getDistricts: districtOptions,
                    getBranchArr: branchOptions,
                    getCities: [],  // Reset cities
                    getSectionArr: [], // Reset sections
                });
            } else {
                // Reset to all data
                const allDistricts = globalsData.districts?.map(d => ({
                    value: d.id,
                    label: d.district_name
                })) || [];

                const allBranches = globalsData.globalBranches?.map(b => ({
                    value: parseInt(b.id),
                    label: b.branch_name
                })) || [];

                this.setState({
                    getDistricts: allDistricts,
                    getBranchArr: allBranches,
                });
            }
        }

        if (filterName === "districts") {
            this.setState({
                selectedDistrictsValues: selectedValues,
                selectedCityValue: [],
                branchSelectedvalue: [],
                sectionSelectedvalue: [],
                examSelectedvalue: [],
                classSelectedvalue: [],
            });

            if (selectedValues.length > 0) {
                const districtIds = selectedValues.map(d => d.value);
                const stateIds = this.state.statesSelectedValue.map(s => s.value);

                // Filter cities based on selected districts
                const filteredCities = globalsData.cities?.filter(
                    city => districtIds.includes(city.district_id)
                ) || [];

                const cityOptions = filteredCities.map(c => ({
                    value: parseInt(c.id),
                    label: c.city_name
                }));

                // Filter branches based on selected districts AND states
                const filteredBranches = globalsData.globalBranches?.filter(
                    branch => districtIds.includes(branch.district_id) &&
                        (stateIds.length === 0 || stateIds.includes(branch.state_id))
                ) || [];

                const branchOptions = filteredBranches.map(b => ({
                    value: parseInt(b.id),
                    label: b.branch_name
                }));

                this.setState({
                    getCities: cityOptions,
                    getBranchArr: branchOptions,
                    getSectionArr: [], // Reset sections
                });
            } else {
                // Reset to all cities and branches based on selected states
                const stateIds = this.state.statesSelectedValue.map(s => s.value);

                const allCities = globalsData.cities?.map(c => ({
                    value: parseInt(c.id),
                    label: c.city_name
                })) || [];

                const filteredBranches = globalsData.globalBranches?.filter(
                    branch => stateIds.length === 0 || stateIds.includes(branch.state_id)
                ) || [];

                const branchOptions = filteredBranches.map(b => ({
                    value: parseInt(b.id),
                    label: b.branch_name
                }));

                this.setState({
                    getCities: allCities,
                    getBranchArr: branchOptions,
                });
            }
        }

        if (filterName === "cities") {
            this.setState({
                selectedCityValue: selectedValues,
                branchSelectedvalue: [],
                sectionSelectedvalue: [],
                examSelectedvalue: [],
                classSelectedvalue: [],
            });

            if (selectedValues.length > 0) {
                const cityIds = selectedValues.map(c => c.value);
                const districtIds = this.state.selectedDistrictsValues.map(d => d.value);
                const stateIds = this.state.statesSelectedValue.map(s => s.value);

                // Filter branches based on selected cities
                const filteredBranches = globalsData.globalBranches?.filter(
                    branch => cityIds.includes(branch.city_id) &&
                        (districtIds.length === 0 || districtIds.includes(branch.district_id)) &&
                        (stateIds.length === 0 || stateIds.includes(branch.state_id))
                ) || [];

                const branchOptions = filteredBranches.map(b => ({
                    value: parseInt(b.id),
                    label: b.branch_name
                }));

                this.setState({
                    getBranchArr: branchOptions,
                    getSectionArr: [], // Reset sections
                });
            } else {
                // Reset to all branches based on selected districts and states
                const districtIds = this.state.selectedDistrictsValues.map(d => d.value);
                const stateIds = this.state.statesSelectedValue.map(s => s.value);

                const filteredBranches = globalsData.globalBranches?.filter(
                    branch => (districtIds.length === 0 || districtIds.includes(branch.district_id)) &&
                        (stateIds.length === 0 || stateIds.includes(branch.state_id))
                ) || [];

                const branchOptions = filteredBranches.map(b => ({
                    value: parseInt(b.id),
                    label: b.branch_name
                }));

                this.setState({ getBranchArr: branchOptions });
            }
        }

        if (filterName === "branch") {
            this.setState({
                branchSelectedvalue: selectedValues,
                sectionSelectedvalue: [],
                examSelectedvalue: [],
                classSelectedvalue: [],
            });

            if (selectedValues.length > 0) {
                const branchIds = selectedValues.map(b => b.value);
                const cityIds = this.state.selectedCityValue.map(c => c.value);
                const districtIds = this.state.selectedDistrictsValues.map(d => d.value);
                const stateIds = this.state.statesSelectedValue.map(s => s.value);

                // Filter sections based on selected branches
                const filteredSections = globalsData.globalSections?.filter(
                    section => branchIds.includes(section.branch_id)
                ) || [];

                const sectionOptions = filteredSections.map(s => ({
                    value: parseInt(s.id),
                    label: s.section_name
                }));

                // Filter exams based on selected branches using b_e_c_s_data
                const branchExamMap = globalsData.b_e_c_s_data?.filter(
                    becs => branchIds.includes(becs.branch_id)
                ) || [];

                const uniqueExamIds = [...new Set(branchExamMap.map(becs => becs.exam_id))];

                const examOptions = globalsData.exams?.filter(
                    exam => uniqueExamIds.includes(parseInt(exam.id))
                ).map(exam => ({
                    value: parseInt(exam.id),
                    label: exam.exam
                })) || [];

                this.setState({
                    getSectionArr: sectionOptions,
                    getExamArr: examOptions,
                    getClassArr: [], // Reset classes
                });
            } else {
                // Reset to all sections and exams
                const allSections = globalsData.globalSections?.map(s => ({
                    value: parseInt(s.id),
                    label: s.section_name
                })) || [];

                const allExams = globalsData.exams?.map(exam => ({
                    value: parseInt(exam.id),
                    label: exam.exam
                })) || [];

                this.setState({
                    getSectionArr: allSections,
                    getExamArr: allExams,
                });
            }
        }

        if (filterName === "section") {
            this.setState({
                sectionSelectedvalue: selectedValues,

            });

            if (selectedValues.length > 0) {
                const sectionIds = selectedValues.map(s => s.value);
                const branchIds = this.state.branchSelectedvalue.map(b => b.value);

                // Filter exams based on selected sections using b_e_c_s_data
                const sectionExamMap = globalsData.b_e_c_s_data?.filter(
                    becs => sectionIds.includes(becs.section_id)
                ) || [];

                const uniqueExamIds = [...new Set(sectionExamMap.map(becs => becs.exam_id))];

                const examOptions = globalsData.exams?.filter(
                    exam => uniqueExamIds.includes(parseInt(exam.id))
                ).map(exam => ({
                    value: parseInt(exam.id),
                    label: exam.exam
                })) || [];

                // Filter classes based on selected sections
                const uniqueClassIds = [...new Set(sectionExamMap.map(becs => becs.class_id))];

                const classOptions = globalsData.classes?.filter(
                    cls => uniqueClassIds.includes(cls.id)
                ).map(cls => ({
                    value: cls.id,
                    label: cls.class
                })) || [];

                this.setState({
                    getExamArr: examOptions,
                    getClassArr: classOptions,
                });
            } else {
                // Reset to all exams and classes based on selected branches
                const branchIds = this.state.branchSelectedvalue.map(b => b.value);

                const branchExamMap = globalsData.b_e_c_s_data?.filter(
                    becs => branchIds.length === 0 || branchIds.includes(becs.branch_id)
                ) || [];

                const uniqueExamIds = [...new Set(branchExamMap.map(becs => becs.exam_id))];

                const examOptions = globalsData.exams?.filter(
                    exam => uniqueExamIds.includes(parseInt(exam.id))
                ).map(exam => ({
                    value: parseInt(exam.id),
                    label: exam.exam
                })) || [];

                const uniqueClassIds = [...new Set(branchExamMap.map(becs => becs.class_id))];

                const classOptions = globalsData.classes?.filter(
                    cls => uniqueClassIds.includes(cls.id)
                ).map(cls => ({
                    value: cls.id,
                    label: cls.class
                })) || [];

                this.setState({
                    getExamArr: examOptions,
                    getClassArr: classOptions,
                });
            }
        }

        if (filterName === "exam") {
            this.setState({
                examSelectedvalue: selectedValues,
                classSelectedvalue: [],
            });

            if (selectedValues.length > 0) {
                const examIds = selectedValues.map(e => e.value);
                const sectionIds = this.state.sectionSelectedvalue.map(s => s.value);
                const branchIds = this.state.branchSelectedvalue.map(b => b.value);

                // Filter classes based on selected exams
                const examClassMap = globalsData.b_e_c_s_data?.filter(
                    becs => examIds.includes(becs.exam_id) &&
                        (sectionIds.length === 0 || sectionIds.includes(becs.section_id)) &&
                        (branchIds.length === 0 || branchIds.includes(becs.branch_id))
                ) || [];

                const uniqueClassIds = [...new Set(examClassMap.map(becs => becs.class_id))];

                const classOptions = globalsData.classes?.filter(
                    cls => uniqueClassIds.includes(cls.id)
                ).map(cls => ({
                    value: cls.id,
                    label: cls.class
                })) || [];

                this.setState({ getClassArr: classOptions });
            } else {
                // Reset to all classes based on selected sections and branches
                const sectionIds = this.state.sectionSelectedvalue.map(s => s.value);
                const branchIds = this.state.branchSelectedvalue.map(b => b.value);

                const classMap = globalsData.b_e_c_s_data?.filter(
                    becs => (sectionIds.length === 0 || sectionIds.includes(becs.section_id)) &&
                        (branchIds.length === 0 || branchIds.includes(becs.branch_id))
                ) || [];

                const uniqueClassIds = [...new Set(classMap.map(becs => becs.class_id))];

                const classOptions = globalsData.classes?.filter(
                    cls => uniqueClassIds.includes(cls.id)
                ).map(cls => ({
                    value: cls.id,
                    label: cls.class
                })) || [];

                this.setState({ getClassArr: classOptions });
            }
        }

        if (filterName === "class") {
            this.setState({
                classSelectedvalue: selectedValues,
            });
        }
    };
    render() {

        console.log(this.props, "getDashBoardExams")
        if (!Cookies.get("token")) {
            this.props.history.push("/login");
            return null;
        }


        const { globals, getCountsForCollegeOverallExams, getStateWiseExamStatsCollegeOverall, getDistrictWiseExamStats } = this.props;
        const isInitialLoading = globals.loading ||
            (getCountsForCollegeOverallExams && getCountsForCollegeOverallExams.loading) ||

            (getStateWiseExamStatsCollegeOverall && getStateWiseExamStatsCollegeOverall.loading);
        const data = this.props.getStateWiseExamStatsCollegeOverall?.getCollegeOverallExams || [];

        const level = data?.[0]?.level || "state";

        if (isInitialLoading || this.state.isDistrictLoading || this.state.isCityLoading || this.state.isBranchLoading || this.state.isSectionLoading) {
            return <PreloaderTwo />;
        }


        console.log(this.state.examTypeOptions, "sdljvnsj",)
        if (globals.error) {
            alert("Server Error. " + globals.error.message);
            return null;
        }

        let globalsData = { ...globals.globals };

        if (
            Cookies.get("userlevel") !== "1" &&
            Cookies.get("userlevel") !== "2"
        ) {
            globalsData.globalBranches = globalsData.globalBranches.filter(
                (item) => item.id === parseInt(Cookies.get("branch_id"))
            );
        }

        const counts = this.props.getCountsForCollegeOverallExams?.getCountsForCollegeOverallExams || [];






        const filterConfig = buildFilterConfig(this.props.globals, this.state);

        // Dynamic Filter Visibility Logic
        let dynamicFilterConfig = filterConfig;
        if (this.state.levelSelectedValue && this.state.levelSelectedValue.length > 0) {
            const selectedLevelValues = this.state.levelSelectedValue.map(l => l.value);
            const maxLevel = Math.max(...selectedLevelValues);

            // Define which filters are visible for which levels
            const visibleNames = new Set(["level"]);
            if (maxLevel >= 1) visibleNames.add("states");
            if (maxLevel >= 2) visibleNames.add("districts");
            if (maxLevel >= 3) visibleNames.add("cities");
            if (maxLevel >= 4) visibleNames.add("branch");
            if (maxLevel >= 5) visibleNames.add("section");
            if (selectedLevelValues.includes(6)) visibleNames.add("exam");
            if (selectedLevelValues.includes(7)) visibleNames.add("class");

            dynamicFilterConfig = filterConfig.filter(f => visibleNames.has(f.name));
        } else {
            // If no level is selected, only show the level selector
            dynamicFilterConfig = filterConfig.filter(f => f.name === "level");
        }

        return (

            <div className={this.state.toggled}>

                <div
                    className="content-wrapper mb-2"
                    style={{ minHeight: "50vh" }}
                >
                    <div className="d-flex justify-content-end col-12">
                        <Col sm={12} className="text-right mb-0 mt-0">
                            <Button onClick={() => this.setState({ showFilter: !this.state.showFilter })}
                                className="btn-sm border-0 bg-transparent"><i className="fa fa-filter" style={{ color: this.state.showFilter ? "#007bff" : "#6c757d" }}></i></Button>
                        </Col>
                    </div>
                    <Container fluid className="pt-4">


                        {this.state.showFilter && <Card as={Card.Body} className='block_white'>

                            <MultiSelectFilters
                                filters={dynamicFilterConfig}  // Dynamic filters
                                onFilterChange={this.handleMultipleSelectInputChange}
                                handleFilter={this.handleFilter}
                                handleReset={this.handleReset}
                            />


                            <Row>


                            </Row>


                        </Card>}
                        {counts ? (
                            <Row className="mb-4 mt-2">
                                <Col xl={2} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-primary">{counts.totalExams || 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Total Exams</span>
                                    </div>
                                </Col>
                                <Col xl={2} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }} >
                                        <h3 className="font-weight-bold mb-2 text-success">{counts.avgScore ? counts.avgScore.toFixed(2) : 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Avg Score</span>
                                    </div>
                                </Col>
                                {/* <Col xl={3} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-info">{counts.avgAccuracy ? counts.avgAccuracy.toFixed(2) : 0}%</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Avg Accuracy</span>
                                    </div>
                                </Col> */}
                                <Col xl={2} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-warning">{counts.bestScore || 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Best Score</span>
                                    </div>
                                </Col>
                                <Col xl={3} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-info">{counts.totalStudents || 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Total Students</span>
                                    </div>
                                </Col>
                            </Row>
                        ) : (
                            <div className="text-center py-5">
                                <p className="text-muted">No report data available for this institution.</p>
                            </div>
                        )}
                        {/* {getTopStudents?.getTopStudents
                            && getTopStudents?.getTopStudents
                                .length > 0 && <TopStudentsChart data={getTopStudents?.getTopStudents.slice(0, 10)
                                } />} */}
                        <Row className="mt-4">
                            <Col xl={12} lg={12} md={12} sm={12}>

                                {this.state.sectionWiseExamStats && this.state.sectionWiseExamStats.length > 0 ? (<CardLessDataTableWithSearch
                                    parentData={this.state.sectionWiseExamStats ? this.state.sectionWiseExamStats : []}
                                    particlecolumns={sectionWiseExamColumns(this.handleExamClick)}
                                    name="Section Wise Exam Report"
                                    tableHeading={this.state.tableHeaderData}
                                    defaultSorted={this.defaultSorted}

                                />) : this.state.branchWiseExamStats && this.state.branchWiseExamStats.length > 0 ? (<CardLessDataTableWithSearch
                                    parentData={this.state.branchWiseExamStats ? this.state.branchWiseExamStats : []}
                                    particlecolumns={branchWiseExamColumns(this.handleExamClick)}
                                    name="Branch Wise Exam Report"
                                    tableHeading={this.state.tableHeaderData}
                                    defaultSorted={this.defaultSorted}

                                />) : this.state.cityWiseExamStats && this.state.cityWiseExamStats.length > 0 ? (<CardLessDataTableWithSearch
                                    parentData={this.state.cityWiseExamStats ? this.state.cityWiseExamStats : []}
                                    particlecolumns={cityWiseExamColumns(this.handleExamClick)}
                                    name="City Wise Exam Report"
                                    tableHeading={this.state.tableHeaderData}
                                    defaultSorted={this.defaultSorted}

                                />) : this.state.districtWiseExamStats && this.state.districtWiseExamStats?.length > 0 ? (
                                    <CardLessDataTableWithSearch
                                        parentData={this.state.districtWiseExamStats ? this.state.districtWiseExamStats : []}
                                        particlecolumns={districtWiseExamColumns(this.handleExamClick)}
                                        name="District Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}

                                    />) :
                                    <CardLessDataTableWithSearch
                                        parentData={getStateWiseExamStatsCollegeOverall?.getStateWiseExamStatsCollegeOverall ? getStateWiseExamStatsCollegeOverall?.getStateWiseExamStatsCollegeOverall : []}
                                        particlecolumns={stateWiseExamColumns(this.handleExamClick)}
                                        name="State Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}

                                    />
                                }
                            </Col>
                        </Row>
                        {this.state.showReportSection && (
                            <Row ref={this.reportRef} style={{ minHeight: "100vh" }}>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <ExamReportForOverall
                                        key={this.state.exam_id}
                                        globals={this.props.globals.globals}
                                        stateData={{ eexamptype: 1 }}
                                        getDashBoardExams={this.props.getDashBoardExams?.getDashBoardExams}
                                        exam_id={this.state.exam_id}
                                        exam_name={this.state.exam_name}
                                        exam_type={this.state.exam_type}
                                        exam_typeValue={this.state.exam_typeValue}
                                        examsglobals={this.state.examsglobals}

                                    />

                                </Col>
                            </Row>
                        )}
                    </Container>
                </div>
            </div>
        );
    }
}

export default compose(
    withRouter,
    withApollo,

    graphql(FETCH_GLOBALS, {
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),

    graphql(FETCH_OVERALL_EXAMS_COUNTS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_type: props.exam_type || 2,
                days: props.days || null,

                state_ids: props.globals.globals.states.map(s => Number(s.state_id)) || null,
                district_ids: props.district_ids?.length ? props.district_ids : null,
                city_ids: props.city_ids?.length ? props.city_ids : null,
                branch_ids: props.branch_ids?.length ? props.branch_ids : null,
                section_ids: props.section_ids?.length ? props.section_ids : null,
            },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
        }),
        name: "getCountsForCollegeOverallExams",
    }),

    graphql(FETCH_STATE_WISE_DATA, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_type: props.exam_type || 2,


                state_ids: props.globals.globals.states.map(s => Number(s.state_id)) || null,
                // props.globals.states
                // ?.length ? props.globals.states.map(s => Number(s.state_id)) : null,

            },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
        }),
        name: "getStateWiseExamStatsCollegeOverall",
    }),

    // graphql(FETCH_TOP_STUDENTS, {
    //     options: (props) => ({
    //         variables: {
    //             institution_id: parseInt(Cookies.get("institutionid")),
    //             exam_type: props.exam_type || 2,
    //             days: props.days || null,
    //             state_id: props.state_id || null,
    //             district_id: props.district_id || null,
    //             city_id: props.city_id || null,
    //             branch_id: props.branch_id || null,
    //             section_id: props.section_id || null
    //         },
    //         fetchPolicy: "network-only",
    //         notifyOnNetworkStatusChange: true,
    //     }),
    //     name: "getTopStudents",
    // }),

    graphql(FETCH_EXAMS, {
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getDashBoardExams",
    }),



)(OverallReportsCollege);
